
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.657 23.997c-.476 0-.923-.185-1.259-.521L.522 20.6C.186 20.264 0 19.817 0 19.341s.185-.923.522-1.26l10.46-10.46a1.769 1.769 0 011.26-.521c.476 0 .923.185 1.259.521l.908.908 2.178-2.178a.744.744 0 011.06 0c.142.141.22.33.22.53s-.078.389-.22.53L15.469 9.59l.907.907a1.784 1.784 0 010 2.519l-10.46 10.46a1.767 1.767 0 01-1.259.521zM12.242 8.6a.28.28 0 00-.199.082l-10.46 10.46a.28.28 0 00-.001.398l2.876 2.876a.28.28 0 00.397 0l10.46-10.46a.282.282 0 000-.397l-1.417-1.417-.021-.019-.02-.022-1.417-1.419a.278.278 0 00-.198-.082zM20.181 4.568a.743.743 0 01-.53-.22.744.744 0 010-1.06l1.533-1.533a.744.744 0 011.06 0 .744.744 0 010 1.06l-1.533 1.533a.743.743 0 01-.53.22zM17.117 3.801a.75.75 0 01-.75-.75V.753a.75.75 0 011.5 0v2.298a.75.75 0 01-.75.75zM20.948 7.632a.75.75 0 010-1.5h2.298a.75.75 0 010 1.5h-2.298zM20.948 11.463a.748.748 0 01-.53-.219l-1.533-1.532a.746.746 0 01.529-1.28c.2 0 .389.078.53.219l1.533 1.532a.752.752 0 010 1.061.74.74 0 01-.529.219zM14.818 5.334a.743.743 0 01-.53-.22l-1.532-1.533a.752.752 0 01.53-1.281c.2 0 .389.078.53.22l1.532 1.533a.752.752 0 01-.53 1.281z"}})])
          )
        }
      }
    